export const channel = new BroadcastChannel('auth');

export function sendLogoutSignal() {
  channel.postMessage({ type: 'logout' });
}